// extracted by mini-css-extract-plugin
module.exports = {"tableCell":"Master_tableCell__3SHTu","numberCell":"Master_numberCell__15sWu","txt":"Master_txt__2hN5d","txtBlue":"Master_txtBlue__2md2M"};